module.exports = __webpack_public_path__ + "static/asesoria01-8eabc9ec24eb72ab262b401572816d76.jpg";